import { render, staticRenderFns } from "./NewFbPostForm.vue?vue&type=template&id=176ddf5c&scoped=true&"
import script from "./NewFbPostForm.vue?vue&type=script&lang=js&"
export * from "./NewFbPostForm.vue?vue&type=script&lang=js&"
import style0 from "./NewFbPostForm.vue?vue&type=style&index=0&id=176ddf5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ddf5c",
  null
  
)

export default component.exports